import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';
import { getUsageLevel } from '@/hooks/useProducerUsage';

interface SoftLimitMessageProps {
  used: number;
  limit: number | null;
  planName?: string;
  resourceName: string; // e.g. "produkter", "bokningsbara aktiviteter"
  /** Optional extra info shown after the main message */
  extraInfo?: string;
}

/**
 * Discrete informational message shown when nearing or at a plan limit.
 * Uses calm, non-punishing copy per spec.
 */
export function SoftLimitMessage({ used, limit, planName = 'Gratis', resourceName, extraInfo }: SoftLimitMessageProps) {
  const level = getUsageLevel(used, limit);

  if (level === 'ok') return null;

  return (
    <Alert className="border-amber-200 bg-amber-50/60 dark:border-amber-900/50 dark:bg-amber-950/20">
      <Info className="h-4 w-4 text-amber-600 dark:text-amber-400" />
      <AlertDescription className="text-sm text-amber-800 dark:text-amber-300">
        {level === 'near'
          ? `Du är nära gränsen för ${planName}-planen (${used} av ${limit} ${resourceName}).`
          : `Du har nått gränsen för ${planName}-planen (${used} av ${limit} ${resourceName}).`}
        {extraInfo && ` ${extraInfo}`}
      </AlertDescription>
    </Alert>
  );
}
